import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    copy: translate({
      id: 'orders.trackingLink.copy',
    }),
    copied: translate({
      id: 'orders.trackingLink.copied',
    }),
    open: translate({
      id: 'orders.trackingLink.open',
    }),
    description: translate({
      id: 'orders.trackingLink.description',
    }),
    sectionTitle: translate({
      id: 'orders.trackingLink.sectionTitle',
    }),
    trackingLinkLabel: translate({
      id: 'orders.trackingLink.label',
    }),

    trackingLinkFailureTitle: translate({
      id: 'orders.trackingLink.failure.title',
    }),

    trackingLinkFailureDescription: translate({
      id: 'orders.trackingLink.failure.description',
    }),
  }))

  return api
}
